import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function Loading() {
  return (
    <Box
      sx={{
        position: 'absolute',
        right: 20,
        bottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1201,
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default Loading;
